const Navbar = () => {
    return (
            <div className="navbar1">
                <ul>
                    <li><a href="https://www.google.com/aclk?sa=l&ai=DChcSEwj6yM7Ghov_AhXEqtUKHebUA_gYABAAGgJ3cw&sig=AOD64_1uW3Y32HuVrxXWYWea9fTR9t0RfQ&q&adurl&ved=2ahUKEwiQ2cfGhov_AhVySfEDHSecAv0Q0Qx6BAgJEAE" target="_blank" >HeadHunter.uz</a></li>
                    <li><a href="https://ishkop.uz/%D0%B2%D0%B0%D0%BA%D0%B0%D0%BD%D1%81%D0%B8%D0%B8/%D0%A2%D0%B0%D1%88%D0%BA%D0%B5%D0%BD%D1%82" target="_blank">Ishkop.uz</a></li>
                    <li><a href="https://tashkent.gorodrabot.uz/"target="_blank">GorodRabot.uz</a></li>
                    <li><a href="https://myjob.uz/"target="_blank">MyJob.uz</a></li>
                    <li><a href="https://uzjobs.uz/"target="_blank">UzJobs.uz</a></li>
                </ul>
        </div>  
    )
}

export default Navbar;

